module.exports = __webpack_public_path__ + "img/item2.f830f7cc.png";